import { render, staticRenderFns } from "./myreservations.vue?vue&type=template&id=436e0756&scoped=true&"
import script from "./myreservations.vue?vue&type=script&lang=js&"
export * from "./myreservations.vue?vue&type=script&lang=js&"
import style0 from "./myreservations.vue?vue&type=style&index=0&id=436e0756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436e0756",
  null
  
)

export default component.exports